(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/button/primary.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/button/primary.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.button = svs.tur.payfooter.button || {};

svs.tur.payfooter.button.PAY_TITLE = 'Betala {amount} kr';
svs.tur.payfooter.button.PAY_TITLE_DISABLED = 'Betala';
class Primary extends svs.tur.payfooter.button.Default {
  constructor(_ref) {
    let {
      title = svs.tur.payfooter.button.PAY_TITLE,
      titleDisabled = svs.tur.payfooter.button.PAY_TITLE_DISABLED,
      listenOn = svs.tur.payfooter.SUM_UPDATED,
      visible = true,
      callback,
      id,
      autoUpdateState = true
    } = _ref;
    super({
      title,
      titleDisabled,
      listenOn,
      callback,
      visible,
      id,
      focus: true
    });
    this.autoUpdateState = autoUpdateState;
    this.log = new svs.core.log.Logger('payfooter:button:primary');
  }
  addEventHandler(eh) {
    if (this.listenOn) {
      eh.on(this.listenOn, data => {
        this.update(data.amount, data.animate);
      });
    }
  }
  update(amount) {
    let animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (animate) {
      this.amount.update(amount);
    } else {
      this.amount.update(amount);
    }
    if (this.autoUpdateState) {
      if (!amount) {
        this.disable();
      } else {
        this.enable();
      }
    }
    gsap.fromTo(this.$el, {
      scaleY: 1.2,
      scaleX: 1.02
    }, {
      duration: 0.2,
      scale: 1,
      clearProps: 'all'
    });
  }
}
svs.tur.payfooter.button.Primary = Primary;

 })(window);